type fieldType =
  | 'string'
  | 'number'
  | 'partner'
  | 'subject'
  | 'grade'
  | 'itemCount'
  | 'productGroup'
  | 'unassignable_at'
  | 'frameworkId'
  | 'crosswalkStatus'
  | 'crosswalkAlignments'

export type fieldColumnType = {
  key: string
  setKey?: string
  valueType: fieldType
  locked?: boolean
}

export type editableResource = {
  title: string
  mutationUpdateKey: string
  mutationAddKey: string
  mutationDeleteKey: string
  editableFields: fieldColumnType[]
  disableUpdates?: boolean
}

export const NEW_ITEM_ID = -42
